import { isReturnFlightOptions } from '@shared/v2/utils/types/flightOptions';

import { ResponseWithFlightOptions } from '../../types';
import { mergeReturnJourneys } from '../mergeReturnJourneys';

export const getFlightOptions = (
  data: ResponseWithFlightOptions[] | undefined,
) => {
  const firstFlightOptions = data?.[0]?.flightOptions;

  if (!firstFlightOptions) {
    return undefined;
  }

  if (isReturnFlightOptions(firstFlightOptions)) {
    return mergeReturnJourneys(data);
  }

  // If not a return journey then we don't use pagination and just return the
  // flight options from the first (and only) page.
  return firstFlightOptions;
};
